import "promise-polyfill/src/polyfill";
import "whatwg-fetch";

const BearerToken = `LHj/1cfITkwIHEO/PUQkSYEzqqKuVw0bLFk8Ho1AprEwvH2sABCSrOxxzlooRDMym0edt13gMOFbnB10+ZP45PFVq5FWWL1/x2Tv9zNK+kKPyO2VDqn1yeI4M8BTDD+8zdLyk7Veauhzr3y1q8hVax5W8wtWBY1kBCQzTul2IR3+b8IOFcE9iK8ziH2dmRd579b9TSmnEZ7n5RffTzi2uJ+/LoSwJWZeCy+I5kHAjheSPHrKMHGJ5eb8Ofagcm86M+P6zHckwX2ewVbRJVC2DzU9zSrj//IZQXmpeOo/A0p5GAbkwoZW1h0TBrS/oClld9J7UEpdwevlepM5g+pH0jIavKYdugkOPllHdVHXnx8oLtMWkBmj11WJDjhvJXZPWvWQmxNHL7IjJPhA6NgOZLdtLNYjK6eQuk2v6s21I06UEw6mJhFmwuMfXqykqnVAGivupTERz/8P4hRP9A5HETXsJwJi1V5qbYSViTGIw/jeJ0Vw0mUjLtl1MxYbGp2Xm0n8CXXj2gzUJPUHkcKkUA4byQVanj3KslhT1dsDuNU=`;

export const api = (() => {
  const isLocal = process.env.NODE_ENV !== "production";

  function checkStatus(response: any) {
    if (response.ok) {
      return response;
    }
    if (response.status >= 200 && response.status < 300) {
      return response;
    } else {
      var error = new Error(response.statusText);
      // @ts-ignore
      error.response = response;
      throw error;
    }
  }

  const get = async ({ url, headers }: { url: string; headers?: any }) => {
    const response = await fetch(url, {
      method: "get",
      headers: {
        ...(isLocal && { Authorization: `Bearer ${BearerToken}` }),
        ...headers,
      },
    });

    return checkStatus(response);
  };

  const post = async ({
    url,
    headers,
    requestBody,
  }: {
    url: string;
    headers?: any;
    requestBody?: any;
  }) => {
    const response = await fetch(url, {
      method: "post",
      headers: {
        ...(isLocal && { Authorization: `Bearer ${BearerToken}` }),
        Accept: "application/json",
        "Content-Type": "application/json",
        ...headers,
      },
      body: JSON.stringify(requestBody),
    });

    return checkStatus(response);
  };

  return {
    get,
    post,
  };
})();

export const logger = (() => {
  const error = ({ message, error }: { message: string; error: unknown }) => {
    console.error(message);
  };

  return {
    error,
  };
})();
